import { render, staticRenderFns } from "./SeatsLegend.vue?vue&type=template&id=7adc0bee&"
import script from "./SeatsLegend.vue?vue&type=script&lang=js&"
export * from "./SeatsLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports